import { memo } from 'react';

import { Deal } from '~/types/deal';

import AverageRating from './AverageRating';
import BreakoutRating from './BreakoutRating';

function DealRatings({ deal }: { deal: Deal }) {
  return (
    <div className="my-6">
      <AverageRating
        average={deal.deal_review.average_rating}
        count={deal.deal_review.review_count}
      />

      <BreakoutRating dealReview={deal.deal_review} />
    </div>
  );
}

export default memo(DealRatings);
